import { useEffect } from 'react';
import { replace } from 'connected-react-router';
import { connect } from 'react-redux';
import { useParams } from 'react-router';

import { getManageCandidatesPath } from '../../common/revamped-path/CandidatePaths';

type ApplicationsPageRedirectProps = {
  redirect: (path: string) => void;
};

const ApplicationsPageRedirect = ({
  redirect,
}: ApplicationsPageRedirectProps) => {
  const { jid } = useParams<{ jid: string }>();

  useEffect(() => {
    if (jid) {
      const redirectSearchParams = new URLSearchParams({
        jid,
      });
      redirect(`${getManageCandidatesPath()}?${redirectSearchParams}`);
    }
  }, [jid, redirect]);

  return null;
};

export default connect(null, dispatch => ({
  redirect: (args: string) => dispatch(replace(args)),
}))(ApplicationsPageRedirect);
